// actionTypes.js
export const SET_VALUE_ModeleInvest = "SET_VALUE_ModeleInvest";
export const SET_TYPE_ModeleInvest = "SET_TYPE_ModeleInvest";
export const SET_CURRENT_PAGE_ModeleInvest = "SET_CURRENT_PAGE_ModeleInvest";
export const SET_ORDER_ModeleInvest = "SET_ORDER_ModeleInvest";
export const SET_SORT_FIELD_ModeleInvest = "SET_SORT_FIELD_ModeleInvest";
export const SET_ACTIF_ModeleInvest = "SET_ACTIF_ModeleInvest";
export const SET_CATEGORIE_ModeleInvest = "SET_CATEGORIE_ModeleInvest";
